<template>
  <k-icon
    :icon="show ? 'eye-hidden' : 'eye'"
    @click="$emit('click')"
  />
</template>

<script>
import KIcon from './KIcon.vue'

export default {
  name: 'ShowPassword',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  },
  components: {
    KIcon
  }
};
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/ShowPassword.vue